// analytics/RouteTracker.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent } from "./analytics_logger";
import { ROUTE_EVENTS } from "./events";

const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const pagePath = location.pathname;
    trackEvent("page_view", {
      page_title: ROUTE_EVENTS[pagePath] || "unknown_page",
      page_path: pagePath
    });
  }, [location]);

  return null;
};

export default RouteTracker;